import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

declare global {
  interface ImportMeta {
    env: any; // eslint-disable-line
  }
}

setTimeout(() => {
  const root = createRoot(document.querySelector('#design-root')!);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}, 750);
